export default __webpack_public_path__ + "static/media/qb.c8211d7a.png";